/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CrmIssueElastic, ApiResponse, CompoApiService} from 'compob2b-libs';
import {map} from 'rxjs/operators';

interface NewSubTask {
  parent: number;
  header: string;
  type: number;
}

@Injectable({ providedIn: 'root' })
export class SubtaskLinkService {

  constructor(private readonly apiService: CompoApiService) {
  }

  load(id: number): Observable<CrmIssueElastic[]> {
    const url = '/issue/' + id + '/subtask';

    return this.apiService.get<CrmIssueElastic[]>(url).pipe(
      map(response => response.data)
    );
  }

  store(payload: NewSubTask): Observable<CrmIssueElastic[]> {
    const url = '/issue/subtask';
    return this.apiService.post<NewSubTask, CrmIssueElastic[]>(url, payload).pipe(
      map((response: ApiResponse<CrmIssueElastic[]>) => response.data)
    );
  }
}
